// Journey theme visuals. All themes currently render the real Zini
// road-trip artwork (journey.png) until theme-specific assets exist.
// Reused by the profile journey cards, the "View All" list, and the
// journey detail hero.

import journeyImg from '../../assets/journey.png';

export default function JourneyScene({ theme = 'mountain', className }) {
  return (
    <div className={className} style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      <img
        src={journeyImg}
        alt=""
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </div>
  );
}
